import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'url-search-params-polyfill';
import GeneralSignature from '../views/GeneralSignature/GeneralSignature';
import { InsightService } from '@pepper/insights-react';
import Success from '../views/Success/Success';
import ErrorComponent from '../views/Error/Error';

const AppRoutes = () => {
  useEffect(() => {
    InsightService.logPageView(location.pathname);
  }, [location.pathname]);

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <GeneralSignature
            />
          }
        />
        <Route
          path='/error'
          element={<ErrorComponent />}
        />
        <Route
          path='/success'
          element={<Success />}
        />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
